<!-- src/components/MarkdownEditor.vue -->
<template>
  <div class="markdown-editor-container">
    <!-- 中间编辑区域 -->
    <div class="editor-wrapper" :style="{ width: editorWidth + 'px' }">
      <div class="editor-header">
        <div class="editor-header-info">
          <!-- 文件名只读显示 -->
           <el-tag v-if="currentFileNameFromStore">{{ currentFileNameFromStore }}</el-tag>
          <span v-else class="editor-file-name editor-file-name-placeholder">未选择文件</span>
            <button class="btn btn-primary" @click="saveFile" :disabled="!currentFilePath || isSaving">
            <span v-if="isSaving">保存中...</span>
            <span v-else> 保存</span>
            </button>
        </div>
        <div class="editor-header-tools">

          <!-- 加粗 -->
          <el-tooltip content="加粗 (Ctrl+B)" placement="bottom">
            <button class="tool-btn" @click="handleBold" :disabled="!editable">
              <i class="tool-icon">𝐁</i>
            </button>
          </el-tooltip>

          <!-- 斜体 -->
          <el-tooltip content="斜体 (Ctrl+I)" placement="bottom">
            <button class="tool-btn" @click="handleItalic" :disabled="!editable">
              <i class="tool-icon">𝐼</i>
            </button>
          </el-tooltip>

          <!-- 下划线 -->
          <el-tooltip content="下划线 (Ctrl+U)" placement="bottom">
            <button class="tool-btn" @click="handleUnderline" :disabled="!editable">
              <i class="tool-icon">𝑈</i>
            </button>
          </el-tooltip>

          <!-- 删除线 -->
          <el-tooltip content="删除线" placement="bottom">
            <button class="tool-btn" @click="handleStrikethrough" :disabled="!editable">
              <i class="tool-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M16 4H8a4 4 0 0 0 0 8h8a4 4 0 0 0 0-8Z"></path>
                  <path d="M8 12v6a4 4 0 0 0 8 0v-2"></path>
                  <line x1="4" y1="12" x2="20" y2="12"></line>
                </svg>
              </i>
            </button>
          </el-tooltip>

          <!-- 分隔线 -->
          <div class="tool-divider"></div>

          <!-- 标题 -->
          <el-tooltip content="标题 (Ctrl+H)" placement="bottom">
            <button class="tool-btn" @click="handleHeading" :disabled="!editable">
              <i class="tool-icon">H</i>
            </button>
          </el-tooltip>

          <!-- 无序列表 -->
          <el-tooltip content="无序列表" placement="bottom">
            <button class="tool-btn" @click="handleUnorderedList" :disabled="!editable">
              <i class="tool-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <line x1="8" y1="6" x2="21" y2="6"></line>
                  <line x1="8" y1="12" x2="21" y2="12"></line>
                  <line x1="8" y1="18" x2="21" y2="18"></line>
                  <line x1="3" y1="6" x2="3.01" y2="6"></line>
                  <line x1="3" y1="12" x2="3.01" y2="12"></line>
                  <line x1="3" y1="18" x2="3.01" y2="18"></line>
                </svg>
              </i>
            </button>
          </el-tooltip>

          <!-- 有序列表 -->
          <el-tooltip content="有序列表" placement="bottom">
            <button class="tool-btn" @click="handleOrderedList" :disabled="!editable">
              <i class="tool-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <line x1="10" y1="6" x2="21" y2="6"></line>
                  <line x1="10" y1="12" x2="21" y2="12"></line>
                  <line x1="10" y1="18" x2="21" y2="18"></line>
                  <path d="M4 6h1v4H4V6z"></path>
                  <path d="M4 10h1v4H4v-4z"></path>
                  <path d="M4 14h1v4H4v-4z"></path>
                </svg>
              </i>
            </button>
          </el-tooltip>

          <!-- 分隔线 -->
          <div class="tool-divider"></div>

          <!-- 链接 -->
          <el-tooltip content="插入链接 (Ctrl+K)" placement="bottom">
            <button class="tool-btn" @click="handleLink" :disabled="!editable">
              <i class="tool-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                  <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
                </svg>
              </i>
            </button>
          </el-tooltip>

          <!-- 图片 -->
          <el-tooltip content="插入图片" placement="bottom">
            <button class="tool-btn" @click="handleImage" :disabled="!editable">
              <i class="tool-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                  <circle cx="8.5" cy="8.5" r="1.5"></circle>
                  <path d="M21 15l-5-5L5 21"></path>
                </svg>
              </i>
            </button>
          </el-tooltip>

          <!-- 代码 -->
          <el-tooltip content="插入代码" placement="bottom">
            <button class="tool-btn" @click="handleCode" :disabled="!editable">
              <i class="tool-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="16 18 22 12 16 6"></polyline>
                  <polyline points="8 6 2 12 8 18"></polyline>
                </svg>
              </i>
            </button>
          </el-tooltip>

          <!-- 表格 -->
          <el-tooltip content="插入表格" placement="bottom">
            <button class="tool-btn" @click="handleTable" :disabled="!editable">
              <i class="tool-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="3" y1="9" x2="21" y2="9"></line>
                  <line x1="9" y1="21" x2="9" y2="9"></line>
                  <line x1="15" y1="21" x2="15" y2="9"></line>
                </svg>
              </i>
            </button>
          </el-tooltip>

          <!-- 分隔线 -->
          <div class="tool-divider"></div>

          <!-- 行内公式 -->
          <el-tooltip content="插入行内公式" placement="bottom">
            <button class="tool-btn" @click="handleInlineMath" :disabled="!editable">
              <i class="tool-icon">𝑥</i>
            </button>
          </el-tooltip>

          <!-- 块级公式 -->
          <el-tooltip content="插入块级公式" placement="bottom">
            <button class="tool-btn" @click="handleBlockMath" :disabled="!editable">
              <i class="tool-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect>
                  <line x1="7" y1="6" x2="17" y2="6"></line>
                  <line x1="7" y1="12" x2="17" y2="12"></line>
                  <line x1="7" y1="18" x2="17" y2="18"></line>
                </svg>
              </i>
            </button>
          </el-tooltip>

          <!-- 引用 -->
          <el-tooltip content="插入引用" placement="bottom">
            <button class="tool-btn" @click="handleQuote" :disabled="!editable">
              <i class="tool-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1.25.756 2.017 2 2zM14 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1.25.757 2.017 2 2z"></path>
                </svg>
              </i>
            </button>
          </el-tooltip>

          <!-- 水平线 -->
          <el-tooltip content="插入水平线" placement="bottom">
            <button class="tool-btn" @click="handleHorizontalRule" :disabled="!editable">
              <i class="tool-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <line x1="3" y1="12" x2="21" y2="12"></line>
                </svg>
              </i>
            </button>
          </el-tooltip>
        </div>
        
      </div>
      
      <div class="editor-body">
        <textarea
          ref="editorTextarea"
          v-model="editorContent"
          class="editor-textarea"
          placeholder="开始编辑 Markdown..."
          :disabled="!editable"
          @scroll="handleEditorScroll"
          @keydown="handleKeydown"
          spellcheck="false"
          autocorrect="off"
          autocapitalize="off"
          autocomplete="off"
        ></textarea>
      </div>
      
    </div>

    <!-- 编辑器与预览区域之间的拖动条 -->
    <div class="resizer" @mousedown="initResize"></div>

    <!-- 右侧预览区域 -->
    <div class="preview-wrapper" :style="{ width: previewWidth + 'px' }">
      <div class="preview-header">
        <div class="preview-header-info">
          <h3>👁️ 预览</h3>
        </div>
          <!-- 主题切换下拉菜单 -->
          <div class="theme-selector">
            <el-select 
              v-model="previewTheme" 
              size="mini" 
              placeholder="选择主题"
            >
              <el-option
                v-for="theme in previewThemes"
                :key="theme.value"
                :label="theme.label"
                :value="theme.value"
              >
              </el-option>
            </el-select>
            <el-tooltip class="item" effect="dark" content="全屏预览" placement="top">
              <i class="full-screen-icon" @click="showFullScreenPriew"></i>
            </el-tooltip>
            <!-- <button class="btn btn-secondary" style="margin-left: 7px;" @click="exportFile"> -->
            <!-- <span v-if="isSaving">导出中...</span> -->
            <!-- <span v-else> 导出PDF</span> -->
            <!-- </button> -->
          </div>
      </div>

      <div class="preview-body" >
        <div v-if="!currentFilePath" class="preview-placeholder">
          <div class="preview-placeholder-icon">📝</div>
          <p>请选择一个文件开始编辑</p>
        </div>
        <div v-else-if="!editorContent" class="preview-placeholder">
          <div class="preview-placeholder-icon">👁️</div>
          <p>在编辑器中输入 Markdown 内容以查看预览</p>
        </div>
        
        <div 
          ref="previewContent"
          v-else 
          id="preview-content" 
          :class="previewThemeClass"
          v-html="renderedContent.html"
          @scroll="handlePreviewScroll"
        ></div>  

        <!-- 悬浮目录按钮 -->
        <div 
          v-if="editorContent && renderedContent.toc" 
          class="toc-toggle-btn"
          @click="toggleTocSidebar"
        >
          <el-tooltip content="显示目录" placement="left">
            <i class="el-icon-notebook-2 toc-icon"></i>            
          </el-tooltip>
        </div>

        <!-- 目录侧边栏 -->
        <transition name="slide">
          <div 
            v-show="showTocSidebar" 
            class="toc-sidebar"
            :style="{ width: tocSidebarWidth + 'px' }"
          >
            <div class="toc-sidebar-header">
              <h3>目录</h3>
              <el-button 
                type="text" 
                icon="el-icon-close" 
                @click="toggleTocSidebar"
                class="toc-close-btn"
              ></el-button>
            </div>
            <div class="toc-sidebar-content" v-html="renderedContent.toc"></div>
          </div>
        </transition>

        <!-- 侧边栏遮罩 -->
        <transition name="fade">
          <div 
            v-show="showTocSidebar" 
            class="toc-sidebar-overlay"
            @click="toggleTocSidebar"
          ></div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import '@/css/MarkdownEditor.css'; // 组件样式
import '@/css/PreviewTheme.css'; // 主题样式
import { file_content_path, file_save_path } from '@/js/api_paths';
import {highlightAllCode, setImgStyles, Render} from '@/js/highlight.js';
import {checkAndConvertImage, isFilePreviewable} from '@/js/tools.js';
import { MarkdownEditorUtils } from '@/js/markdown_utils.js'; // 导入工具类
import { generateReport } from '@/utils/pdfTemplate.js';


export default {
  name: 'MarkdownEditor',
  components: {
  },
  // 新增：定义 prop
  props: {
    containerWidth: {
      type: Number,
      default: 0 // 默认值，或在 mounted 中处理
    }
  },
  data() {
    return {
      lockImg: false,
      md: null,
      isResizing: false,
      startX: 0,
      startEditorWidth: 0,
      startPreviewWidth: 0,
      previewWidth: 500, // 初始预览宽度
      editorWidth: 0,   // 将在 mounted 和 resize 中计算
      isSaving: false,
      isExporting: false,
      editorContent: '',
      isSyncingScroll: false,     // 防止滚动事件循环调用
      previewTheme: '0',           // 预览主题，默认为空（默认主题）
      previewThemes: [            // 预览主题选项
        { value: '0', label: '默认主题' },
        { value: '7', label: '缤纷虹' },
        { value: '6', label: '可爱粉' },
        { value: '5', label: '清新蓝' },
        { value: '1', label: '经典白' },
        { value: '2', label: '暗夜黑' },
        { value: '3', label: '护眼绿' },
        { value: '4', label: '简约灰' },
      ],
      // 新增：锚点滚动相关数据
      scrollOffset: 60, // 滚动偏移量
      // 新增：目录侧边栏相关数据
      showTocSidebar: false,
      tocSidebarWidth: 250
    };
  },
  created() {
  },
  computed: {
    editable(){ // 编辑器是否处于可编辑状态
      return this.currentFilePath != '' && !this.lockImg; // 只有当前选中文件且选择的不是图片, 才可编辑
    },
    currentFilePath() {
      return this.$store.state.currentFilePath;
    },
    currentFileNameFromStore() {
      return this.$store.state.currentFilePath.split('/').pop();
    },
    FileCache(){
        return this.$store.state.fileCache;
    },
    renderedContent(){
      return Render(this.editorContent, this.$store.state.email)
    },
    // 计算预览主题的CSS类名
    previewThemeClass() {
      return `theme-${this.previewTheme}`;
    },
    // 监听图片选择信号
    chooseImgSignal() {
      return this.$store.state.chooseImgSignal;
    }
  },
  watch: {
    currentFilePath(_, oldPath) { // 当监听到文件发生变化时, 重新获取待编辑的内容

      this.$store.commit("SET_FILE_CACHE", { // 先把当前的编辑缓存起来
        path : oldPath,
        content : this.editorContent
      });

      this.getFileContent();
    },
    previewWidth() {
      this.calculateWidths();
    },
    // 新增：监听 containerWidth prop 的变化
    containerWidth(newWidth) {
        if (newWidth > 0) { // 确保宽度有效
            this.$nextTick(this.calculateWidths);
            // 或者直接调用 this.calculateWidths();
        }
    },
    editorContent(){ // 监听编辑器内容变化以执行渲染
      this.$nextTick(()=>{
        setImgStyles();
        highlightAllCode();
      })
    },
    // 监听图片选择信号
    chooseImgSignal() {
      this.insertImg();
    },
    // 监听目录侧边栏显示状态
    showTocSidebar(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          // 为目录链接添加点击事件
          this.setupTocClickHandlers();
        });
      }
    }
  },
  mounted() {
    // 组件挂载后立即计算一次宽度
    this.calculateWidths();
    window.addEventListener('resize', this.handleWindowResize);
    document.addEventListener('mousemove', this.onMouseMove);
    document.addEventListener('mouseup', this.stopResize);
    this.getFileContent();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
    document.removeEventListener('mousemove', this.onMouseMove);
    document.removeEventListener('mouseup', this.stopResize);
    
    // 移除目录点击事件监听器
    const tocContainer = document.querySelector('.toc-sidebar-content');
    if (tocContainer) {
      tocContainer.removeEventListener('click', this.handleTocClick);
    }
  },
  methods: {

    async getFileContent() {
      // 如果正在加载内容，禁止切换文件
      if (this.$store.state.isLoadingContent) {
        this.$message?.warning('正在加载文件内容，请稍候...');
        return;
      }
      if(this.currentFilePath == '')return; // 文件路径为空,直接返回
      
      // 重置状态
      this.editorContent = '';
      this.$store.commit("SET_IS_LOADING_CONTENT", true);  // 开始加载
      
      if (!isFilePreviewable(this.currentFilePath)) {
        this.editorContent = '该文件不支持编辑预览';
        this.$store.commit("SET_IS_LOADING_CONTENT", false);  // 加载完成
        return;
      }
      
      let img_check = checkAndConvertImage(this.currentFilePath);
      if (img_check.isImage) {
        this.lockImg = true; // 如果是图片文件, 编辑框应该锁住, 因为图片将会被转换成图片链接插入markdown编辑器中, 如果可编辑, 用户保存时就会将图片文件变成文本
        this.editorContent = img_check.result;
        this.$store.commit("SET_IS_LOADING_CONTENT", false);  // 加载完成
        setTimeout(() => {
          setImgStyles();
        }, 100);
        return;
      }
      this.lockImg = false; // 如果是文本类文件则可编辑
      
      // 1. 检查缓存
      if (this.FileCache.has(this.currentFilePath)) {
        const content = this.FileCache.get(this.currentFilePath);
        if(content != ''){
          // 直接赋值
          this.editorContent = content;
          this.$store.commit("SET_IS_LOADING_CONTENT", false);  // 加载完成
          return;
        }
        
      }

      // 2. 如果没有缓存，则从后端获取
      const loadingInstance = this.$loading({
        target: '.editor-body',
        lock: true,
        text: '正在从云端获取文件...',
        spinner: 'el-icon-loading',
        background: 'rgba(230, 230, 230, 0.7)',
        customClass: 'markdown-editor-loading'
      });

      let req = {
        "relative_path": this.currentFilePath
      };
      let token = this.$store.state.token;

      // 发送到后端接口
      fetch(file_content_path, {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + token,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
      })
      .then(response => {
        if (!response.ok) {
          return response.json().then(errData => {
            throw new Error(errData.msg || `网络请求失败: ${response.status} ${response.statusText}`);
          }).catch(e => {
            if (e instanceof SyntaxError) {
              throw new Error(`网络请求失败: ${response.status} ${response.statusText}`);
            } else {
              throw e;
            }
          });
        }
        return response.json();
      })
      .then(data => {
        if (data.status === "success") {
          // 直接赋值内容
          this.editorContent = data['msg']['content'];
          this.$store.commit("SET_FILE_CACHE", {
            path: this.currentFilePath,
            content: this.editorContent
          });
        } else {
          throw new Error(data.msg || "获取文件内容失败");
        }
      })
      .catch(error => {
        console.error("获取文件内容失败:", error);
        this.$message?.error(error.message || '获取文件内容失败');
      })
      .finally(() => {
        this.$nextTick(() => {
          loadingInstance.close();
          this.$store.commit("SET_IS_LOADING_CONTENT", false);  // 加载完成
        });
      });
    },

    // 处理编辑器滚动事件
    handleEditorScroll(event) {
      if (this.isSyncingScroll) return;
      
      this.isSyncingScroll = true;
      const textarea = event.target;
      const scrollPercentage = textarea.scrollTop / (textarea.scrollHeight - textarea.clientHeight);
      
      // 同步预览区域滚动
      const previewElement = this.$refs.previewContent;
      if (previewElement) {
        const previewScrollTop = scrollPercentage * (previewElement.scrollHeight - previewElement.clientHeight);
        const diff = Math.abs(previewScrollTop - previewElement.scrollTop);
        
        // 只有当差异超过2像素时才同步，避免微小差异导致的抖动
        if (diff > 2) {
          previewElement.scrollTop = previewScrollTop;
        }
      }
      
      setTimeout(() => {
        this.isSyncingScroll = false;
      }, 16); // 约一帧的时间
    },

    // 处理预览区域滚动事件
    handlePreviewScroll(event) {
      if (this.isSyncingScroll) return;
      
      this.isSyncingScroll = true;
      const previewElement = event.target;
      const scrollPercentage = previewElement.scrollTop / (previewElement.scrollHeight - previewElement.clientHeight);
      
      // 同步编辑器滚动
      const textarea = this.$refs.editorTextarea;
      if (textarea) {
        const editorScrollTop = scrollPercentage * (textarea.scrollHeight - textarea.clientHeight);
        const diff = Math.abs(editorScrollTop - textarea.scrollTop);
        
        // 只有当差异超过2像素时才同步，避免微小差异导致的抖动
        if (diff > 2) {
          textarea.scrollTop = editorScrollTop;
        }
      }
      
      setTimeout(() => {
        this.isSyncingScroll = false;
      }, 16); // 约一帧的时间
    },
    // 修改：calculateWidths 方法使用 prop 或自身元素宽度
    calculateWidths() {
      // 优先使用通过 prop 传递的宽度
      let totalWidth = this.containerWidth;

      // 如果 prop 没有提供有效宽度，则回退到基于 DOM 的计算
      if (!totalWidth || totalWidth <= 0) {
          const container = this.$el?.parentElement;
          if (!container) return;
          totalWidth = container.clientWidth;
      }

      const resizerWidth = 6; // 拖动条宽度

      // 确保预览宽度在合理范围内
      this.previewWidth = Math.max(300, Math.min(this.previewWidth, totalWidth - 300 - resizerWidth));

      // 计算编辑器宽度
      this.editorWidth = totalWidth - this.previewWidth - resizerWidth;

      // 防止编辑器过窄
      if (this.editorWidth < 300) {
        this.editorWidth = 300;
        this.previewWidth = totalWidth - this.editorWidth - resizerWidth;
      }
    },
    // 修改：handleWindowResize 也使用新的 calculateWidths
    handleWindowResize() {
      this.calculateWidths(); // 这会使用 prop 或重新计算的宽度
    },
    // --- 拖动逻辑 (通常不需要修改，因为它操作的是组件内部的 previewWidth) ---
    initResize(event) {
      this.isResizing = true;
      this.startX = event.clientX;
      this.startEditorWidth = this.editorWidth;
      this.startPreviewWidth = this.previewWidth;
      document.body.style.userSelect = 'none';
      document.body.style.cursor = 'col-resize';
      event.preventDefault();
    },
    onMouseMove(event) {
      if (!this.isResizing) return;

      const dx = event.clientX - this.startX;
      // 使用内部计算的宽度作为基准，或者再次使用 prop
      // 最安全的方式是使用当前已知的总宽度
      // 但由于 prop 可能变化，我们基于当前的 editorWidth + previewWidth + resizerWidth 来计算
      const currentTotalWidth = this.editorWidth + this.previewWidth + 6; // 6 是 resizerWidth
      const minWidth = 300;

      let newPreviewWidth = this.startPreviewWidth - dx;
      let newEditorWidth = this.startEditorWidth + dx;

      // 限制最小宽度
      if (newPreviewWidth < minWidth) {
        newPreviewWidth = minWidth;
        newEditorWidth = currentTotalWidth - newPreviewWidth - 6;
      }
      if (newEditorWidth < minWidth) {
        newEditorWidth = minWidth;
        newPreviewWidth = currentTotalWidth - newEditorWidth - 6;
      }

      this.previewWidth = newPreviewWidth;
      // 触发 watcher 或直接调用 calculateWidths 来确保一致性（虽然可能不必要）
      // this.calculateWidths();
    },
    stopResize() {
      this.isResizing = false;
      document.body.style.userSelect = '';
      document.body.style.cursor = '';
    },
    // --- 保存与导出 (通常不需要修改) ---
    async saveFile() {
      let token = this.$store.state.token;
      let req = {
        "relative_path" : this.currentFilePath,
        "file_content" : this.editorContent
      };
      fetch(file_save_path, {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + token,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
      })
      .then(response => {
        if (!response.ok) {
          return response.json().then(errData => {
            throw new Error(errData.msg || `网络请求失败: ${response.status} ${response.statusText}`);
          }).catch(e => {
            if (e instanceof SyntaxError) {
              throw new Error(`网络请求失败: ${response.status} ${response.statusText}`);
            } else {
              throw e;
            }
          });
        }
        return response.json();
      })
      .then(data => {
        if (data.status === "success") {
          this.$message?.success("保存成功");
        } else {
          throw new Error(data.msg || "保存失败");
        }
      })
      .catch(error => {
        console.error("保存文件失败:", error);
        this.$message?.error(error.message || '保存文件失败');
      });
    },

    // 实际的图片链接插入逻辑
    insertImg() {
      let imgPath = this.$store.state.selectedImgPath;
      if (imgPath) {
        MarkdownEditorUtils.insertImg(this, imgPath);
      }
    },
    
    // 使用工具类的方法
    handleBold() {
      MarkdownEditorUtils.handleBold(this);
    },
    
    handleItalic() {
      MarkdownEditorUtils.handleItalic(this);
    },
    
    handleUnderline() {
      MarkdownEditorUtils.handleUnderline(this);
    },
    
    handleStrikethrough() {
      MarkdownEditorUtils.handleStrikethrough(this);
    },
    
    handleHeading() {
      MarkdownEditorUtils.handleHeading(this);
    },
    
    handleUnorderedList() {
      MarkdownEditorUtils.handleUnorderedList(this);
    },
    
    handleOrderedList() {
      MarkdownEditorUtils.handleOrderedList(this);
    },
    
    handleLink() {
      MarkdownEditorUtils.handleLink(this);
    },
    
    handleCode() {
      MarkdownEditorUtils.handleCode(this);
    },
    
    handleTable() {
      MarkdownEditorUtils.handleTable(this);
    },
    
    handleQuote() {
      MarkdownEditorUtils.handleQuote(this);
    },
    
    handleHorizontalRule() {
      MarkdownEditorUtils.handleHorizontalRule(this);
    },

    // 插入图片和数学公式的方法暂时保留为占位符
    handleImage() { 
      // 选择图片的模态框可见
      this.$store.commit('SET_SHOW_SELECT_IMG_MODAL', true);
    },
    
    handleInlineMath() { 
      MarkdownEditorUtils.handleInlineMath(this);
    },
    
    handleBlockMath() { 
      MarkdownEditorUtils.handleBlockMath(this);
    },

    exportFile(){
      generateReport(10, 'report.pdf');
    },

    // 快捷键处理
    handleKeydown(event) {
      // Ctrl + S 保存
      if (event.ctrlKey && event.key === 's') {
        event.preventDefault();
        this.saveFile();
      }

      // Ctrl + A 全选
      if (event.ctrlKey && event.key === 'a') {
        event.preventDefault();
        this.$refs.editorTextarea.select();
      }
      
      // ESC 关闭目录侧边栏
      if (event.key === 'Escape' && this.showTocSidebar) {
        event.preventDefault();
        this.toggleTocSidebar();
      }
    },
    
    // 新增：滚动到指定标题（优化版）
    scrollToHeading(targetId) {
      try {
        const previewContainer = this.$refs.previewContent;
        if (!previewContainer || !targetId) {
          return;
        }
        
        const targetElement = previewContainer.querySelector(`#${targetId}`);
        if (!targetElement) {
          return;
        }
        
        // 使用更安全的计算方式
        const targetPosition = targetElement.offsetTop - this.scrollOffset;
        
        // 边界检查
        const maxScroll = Math.max(0, previewContainer.scrollHeight - previewContainer.clientHeight);
        const safePosition = Math.max(0, Math.min(targetPosition, maxScroll));
        
        // 验证数值有效性
        if (!isFinite(safePosition)) {
          return;
        }
        
        // 执行滚动
        previewContainer.scrollTo({
          top: safePosition,
          behavior: 'auto'
        });
        
        return;
        
      } catch (error) {
        console.error('滚动失败:', error);
        return;
      }
    },
    
    // 新增：切换目录侧边栏
    toggleTocSidebar() {
      this.showTocSidebar = !this.showTocSidebar;
    },
    
    // 新增：为目录链接添加点击事件处理
    setupTocClickHandlers() {
      const tocContainer = document.querySelector('.toc-sidebar-content');
      if (tocContainer) {
        // 移除之前的事件监听器（避免重复绑定）
        tocContainer.removeEventListener('click', this.handleTocClick);
        
        // 添加新的事件监听器
        tocContainer.addEventListener('click', this.handleTocClick);
      }
    },
    
    // 新增：处理目录链接点击
    handleTocClick(event) {
      const link = event.target.closest('a[href^="#"]');
      if (link) {
        event.preventDefault();
        const targetId = link.getAttribute('href').substring(1);
        if (targetId) {
          this.scrollToHeading(targetId);
          // 点击目录项后关闭侧边栏
          this.showTocSidebar = false;
        }
      }
    },
    showFullScreenPriew(){
      this.$store.commit("SET_RENDERED_CONTENT", this.renderedContent); // 将渲染好的html内容传递到全局变量
      this.$store.commit("SET_FILE_CACHE", { // 先把当前的编辑缓存起来
        path : this.currentFilePath, // 当前正在编辑的文件路径
        content : this.editorContent
      });
      this.$router.push('/preview');
    }

  },
};
</script>

<style scoped>



</style>